// extracted by mini-css-extract-plugin
export default {"menu":"menu--Ghoo2","content":"content--E43xM"};